/**
 * RequireAuth — route guard (US-AE1.F1-0001 · @UC9001, AC-guard).
 * Chưa có access token in-memory → redirect /login. Đây là TIỆN ÍCH UI;
 * quyền thật enforce ở backend (S01). Ẩn route KHÔNG được coi là bảo mật.
 */
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "@/lib/auth.js";

export interface RequireAuthProps {
  readonly children: ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  if (!getToken()) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
